import { BaseAPI } from '@/lib/api';

export interface StatisticsData {
  total_queries: number;
  avg_query_time: number;
  slow_queries_count: number;
  recent_avg_time: number;
  indices_count: number;
  slow_indices: Array<{
    name: string;
    avg_time: number;
    count: number;
    hits: number;
  }>;
  last_update: string;
}

export interface AdminResponse<T = any> {
  ok: boolean;
  data?: T;
  error?: string;
}

class AdminAPI extends BaseAPI {
  // Получение статистики ES
  async getESPerformance(): Promise<StatisticsData> {
    const response = await this.makeRequest<StatisticsData | AdminResponse<StatisticsData>>('/api/auth/admin/es_performance');
    
    // Обрабатываем разные форматы ответа
    if ('total_queries' in response) {
      // Прямой объект со статистикой (api_auth.py)
      return response as StatisticsData;
    } else if ('ok' in response && response.ok && response.data) {
      // Формат admin.py: { ok: true, data: {...} }
      return response.data;
    }
    
    throw new Error('Unexpected response format');
  }

  // Сброс метрик ES
  async resetESMetrics(): Promise<AdminResponse> {
    return this.makeRequest<AdminResponse>('/admin/api/es_performance/reset', {
      method: 'POST',
    });
  }
}

export const adminAPI = new AdminAPI();
